<template>
  <div id="app" :style="{ height: bodyHeight + 'px' }">
    <router-view
      class="content"
      @doMusic="doMusic"
      :bootData="allPlayMusic"
      :class="{'': tabbarVisible && !$store.getters.isIphoneX, 'content-tabbar-iphonex-show': $store.getters.isIphoneX && tabbarVisible}"
    />
    <div class="audio">
      <!--背景音乐-->
      <audio id="music1" :loop="true">
        <source src="./assets/music/bgMusic.mp3" />
      </audio>
      <!--按键音乐-->
      <audio id="music2">
        <source src="./assets/music/butMusic.mp3" />
      </audio>
      <!--5秒倒计时-->
      <audio id="playMusic">
        <source src="./assets/music/playMusic.mp3" />
      </audio>
    </div>
    <div class="fix-iphonex-button" v-if="$store.getters.isIphoneX && !tabbarVisible"></div>
  </div>
</template>

<script>
import router from "./router";
import util from "@/utils/util";
export default {
  name: "App",
  data() {
    return {
      payGame: false,
      tabbarVisible: true,
      bodyHeight: "",
      playFlag: true, // 背景音乐播放状态
      butPlayFlag: false, // 按钮音乐播放状态
      allPlayMusic: true //  是开启闭音效
    };
  },
  created() {
    this.init();
    this.getPhoneModel();
  },
  mounted() {
   util.updatedVersion("3");
    this.autoPlayMusic(true);
   // this.autoPlayMusic(false,2);
    //this.bodyHeight = document.documentElement.clientHeight;
  },
  methods: {
    // 按钮音乐播放
    playButMusic() {
      var audio = document.getElementById("music2");
      if (this.allPlayMusic) {
        audio.play(); // 播放
      }
    },
    // 操作音乐 type[0]：播放类型, colseAll 关闭播放音乐 openAll 开启播放音乐  but 调用按钮音乐 open 打开背景音乐 gameMusicOpen 打开塔防怪物进攻音乐 gameMusicColse 关闭塔防怪物进攻音乐
    doMusic(type) {
      let playType = type[0];
      switch (playType) {
        case "but":
          this.playButMusic();
          break;
        case "colseAll":
          this.allPlayMusic = false;
          // this.payMusic();
          this.autoPlayMusic(false, 1);
          break;
        case "openAll":
          this.allPlayMusic = true;
          // this.payMusic();
          this.autoPlayMusic(true);
          break;
        case "open":
          this.allPlayMusic = true;
          //this.payMusic();
          this.autoPlayMusic(true);
          break;
        case "gameMusicOpen":
          this.autoPlayMusic(true, 2);
          //this.playGameMusic("play");
          break;
        case "gameMusicColse":
          this.autoPlayMusic(false, 2);
          //this.playGameMusic("colse");
          break;
      }
    },
    init() {
      // 设置导航栏
      let title = this.$route.meta.title
        ? this.$route.meta.title
        : "世纪伊甸园";
    },
    // 获取手机型号
    getPhoneModel() {
      var u = navigator.userAgent;
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      var isIphoneX = false;
      if (
        (!isIOS && screen.height == 375 && screen.width == 812) ||
        (screen.height == 812 && screen.width == 375)
      ) {
        isIphoneX = true;
      }
      if (
        (screen.height == 320 && screen.width == 694) ||
        (screen.height == 694 && screen.width == 320)
      ) {
        isIphoneX = true;
      }
      if (
        (screen.height == 414 && screen.width == 896) ||
        (screen.height == 896 && screen.width == 414)
      ) {
        isIphoneX = true;
      }
      if (
        (screen.height == 360 && screen.width == 760) ||
        (screen.height == 760 && screen.width == 360)
      ) {
        isIphoneX = true;
      }
      console.log("isIphoneX", isIphoneX);
      this.$store
        .dispatch("GetModelType", isIphoneX)
        .then(() => {
          console.log("isIphoneX", this.$store.getters.isIphoneX);
        })
        .catch(res => {});
    },
    // 游戏音乐
    playGameMusic(type) {
      let playMusic = document.getElementById("playMusic");
      if (type == "play") {
        playMusic.play();
      } else {
        playMusic.pause(); // 暂停
      }
    },
    // 播放背景音乐
    autoPlayMusic(play, type = 1) {
      // 自动播放音乐效果，解决浏览器或者APP自动播放问题
      if (type == 1) document.body.addEventListener("touchstart", this.musicInBrowserHandler(play, type));
      else document.body.addEventListener("touchstart", this.dogameMusic(play, type));
    },
    // 添加触摸事件
    musicInBrowserHandler(play, type) {
      this.musicPlay(play, type);
      document.body.removeEventListener("touchstart", this.musicInBrowserHandler);
    },
    dogameMusic(play, type) {
      this.musicPlay(play, type);
      document.body.removeEventListener("touchstart", this.dogameMusic);
    },
    // 播放音乐
    musicPlay(isPlay, type = 1) {
      let playMusic = true;
      var audio = "";
      if (type == 1) audio = document.getElementById("music1");
      else audio = document.getElementById("playMusic");
      if (isPlay && audio.paused) {
        audio.play();
        playMusic = true;
      }

      if (!isPlay && !audio.paused) {
        audio.pause();
        playMusic = false;
      }
      this.$store
        .dispatch("GetUserMusic", playMusic)
        .then(() => {
        })
        .catch(() => {});
    }
  },
  watch: {
    $route: "init"
  },
  destroyed: function() {}
};
</script>
<style lang="scss">
#app {
  font-family: "微软雅黑", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
  min-height: 100%;
}
.content {
  width: 100%;
  padding-bottom: 0;
}
.content-tabbar-show {
  padding-bottom: 1.2rem;
}
.content-tabbar-iphonex-show {
  // padding-bottom: 1.54rem;
} 
/* 兼容iphonex吸底 */
.fix-iphonex-button {
  width: 100%;
  height: 0.34rem;
}
.music1 {
  display: none;
}
.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  display: inline-block;
}
/* Hides from IE-mac \*/
* html .clearfix {
  height: 1%;
}
.clearfix {
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/App.vue